import { render, staticRenderFns } from "./TeamChatDetailMenuList.vue?vue&type=template&id=fac685d0"
import script from "./TeamChatDetailMenuList.vue?vue&type=script&lang=js"
export * from "./TeamChatDetailMenuList.vue?vue&type=script&lang=js"
import style0 from "./TeamChatDetailMenuList.vue?vue&type=style&index=0&id=fac685d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports